export const searchFormOption = function () {
    return [
        {
          prop: "keyword",
          label: "关键字",
          type: "input",
          placeholder: "请输入车架号/车牌号",
          width: "20%",
        },
        {
          prop: "dateList",
          label: "提交时间",
          type: "range-date",
          width: "20%",
        },
        {
          prop: "orgNo",
          label: "出单机构",
          type: "cascader",
          placeholder: "请选择内容",
          propConfig: {
            children: "children",
            label: "orgName",
            value: "id",
            checkStrictly: true,
            emitPath: false,
          },
          options: this.$store.state.app.orgList,
          width: "20%",
        },
        {
          prop: "saleNo",
          label: "业务员",
          type: "select",
          width: "20%",
          options: this.$store.state.app.salesmanList,
        },
        {
          prop: "status",
          label: "状态",
          type: "select",
          width: "20%",
          options: this.$emun.apprStatus,
        },
    ]
}

export const auditFormOption = function() {
    return [
      {
        prop: 'res',
        label: '审核结果',
        type: 'radio',
        options: [
            {
                label: '通过',
                value: 1
            },
            {
                label: '不通过',
                value: 0
            }
        ]
      },
      {
        prop: 'auditRemark',
        label: '备注',
        type: 'textarea',
        placeholder: '请输入内容'
      },
    ]
  }

  export const cashFormOption = function() {
    return [
      {
        prop: 'c_contractFee',
        label: '应收差额(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'c_netFee',
        label: '净费差额(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'c_cashFee',
        label: '现金折扣差额(元)',
        type: 'input',
        disabled: true,
      },
      {
        prop: 'inType',
        label: '收款方式',
        type: 'checkbox',
        options: this.$emun.patModeOption
      },
    ]
  }

export default {}